var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 21 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d0mufdw7wa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 747",
    style: {
      fill: "none"
    },
    d: "M0 0h14.588v15.257H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 181"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 180",
    transform: "translate(1.382 .732)",
    style: {
      clipPath: "url(#d0mufdw7wa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 568",
    d: "M7.8 7.127a3.6 3.6 0 0 1-3.722-3.463A3.6 3.6 0 0 1 7.8.2a3.6 3.6 0 0 1 3.719 3.464A3.6 3.6 0 0 1 7.8 7.127m0-6.314a2.965 2.965 0 0 0-3.064 2.851A2.965 2.965 0 0 0 7.8 6.515a2.965 2.965 0 0 0 3.061-2.851A2.965 2.965 0 0 0 7.8.813",
    transform: "translate(-.503 .921)",
    style: {
      fill: "#13249f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 570",
    d: "M12.054 18.527H.529a.318.318 0 0 1-.329-.306 5.9 5.9 0 0 1 6.091-5.674 5.9 5.9 0 0 1 6.091 5.674.318.318 0 0 1-.329.307M.867 17.915h10.848a5.292 5.292 0 0 0-5.424-4.755 5.292 5.292 0 0 0-5.424 4.755",
    transform: "translate(1.003 -4.39)",
    style: {
      fill: "#13249f"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.cb5c9db817ff458acdcf31f19d3524ee.svg";
export { ForwardRef as ReactComponent };